import { createElement } from "@wordpress/element";

/**
 * Internal dependencies
 */
import { StyledSpinner } from './styles/spinner-styles';
export default function Spinner() {
  return createElement(StyledSpinner, {
    className: "components-spinner"
  });
}
//# sourceMappingURL=index.js.map